export default __webpack_public_path__ + "static/media/emotion.e92e314a.jpeg";